import normalizePathname from '@/lib/routes/normalizePathname.js';

const getChromePrimaryActionIdFromPath = (path) => {
  const normalizedPath = normalizePathname(path);

  if (normalizedPath === '/skills' || normalizedPath.startsWith('/skills/')) {
    return 'skills';
  }

  if (normalizedPath === '/connections' || normalizedPath.startsWith('/connections/')) {
    return 'connections';
  }

  if (normalizedPath === '/full-service' || normalizedPath.startsWith('/full-service/')) {
    return 'fullService';
  }

  if (normalizedPath === '/automations' || normalizedPath.startsWith('/automations/')) {
    return 'automations';
  }

  if (normalizedPath === '/analytics' || normalizedPath.startsWith('/analytics/')) {
    return 'analytics';
  }

  return 'home';
};

export default getChromePrimaryActionIdFromPath;
